/**
 * SOLVE module's role → privilege map (Authorization & Collaboration Model v2,
 * ADR-0019). Lives in `@playbookai/types` so the frontend affordance layer and
 * the playbook-be guards consume the SAME map through the shared `authorize()`
 * — UI affordances cannot drift from server decisions.
 *
 * Adding a role is a one-line change here; every endpoint still works because
 * they ask for privileges, not roles. Verbs without routes yet (`pace_ai`,
 * `approve_ai`, `lock_card`, `call_vote`, …) are RESERVED by the model and
 * granted now so their future routes need only a guard config. Proposal
 * approval is deliberately Owner/Facilitator-only.
 *
 * There is deliberately no `facilitator` row: the Facilitator is a persistent
 * owner-granted privilege OVERLAY computed at decision time as
 * owner − {delete, transfer, grant_facilitator, revoke_facilitator}
 * (`facilitatorPrivileges` in `@playbookai/auth-client/rbac`), never a role.
 *
 * `request_unlock` is a Collaborator affordance (the matrix gives Owners no
 * use for it — they unlock directly). The `satisfies` clause provably covers
 * every SolveRole with valid privileges.
 */
export const SOLVE_PRIVILEGES = {
    owner: [
        "view",
        "edit",
        "advance_phase",
        "close_phase",
        "close_instance",
        "lock_card",
        "call_vote",
        "contribute_ai",
        "pace_ai",
        "approve_ai",
        "manage_members",
        "grant_facilitator",
        "revoke_facilitator",
        "change_settings",
        "transfer",
        "delete",
        "lock_canvas",
        "unlock_canvas",
        "lock_phase",
        "unlock_phase",
    ],
    collaborator: ["view", "edit", "contribute_ai", "request_unlock"],
    viewer: ["view"],
};
//# sourceMappingURL=solve-privileges.js.map